import { render, staticRenderFns } from "./modalHonorarios.vue?vue&type=template&id=fb96258c&scoped=true&"
import script from "./modalHonorarios.vue?vue&type=script&lang=js&"
export * from "./modalHonorarios.vue?vue&type=script&lang=js&"
import style0 from "./modalHonorarios.vue?vue&type=style&index=0&id=fb96258c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb96258c",
  null
  
)

export default component.exports